import { authPinia } from '@/store/auth'
import { ajaxApi } from '@/request/request'
import { RoleAuthRes } from '@/interface/api/role'

const getRoleAuth = () => {
  const { setAuth } = authPinia()
  const getAuth = async () => {
    const res = await ajaxApi<RoleAuthRes>('roleAuth', '', '1')
    if (res) {
      setAuth(res.data)
    }
  }
  return {
    getAuth
  }
}
export default getRoleAuth
